import { getAPIErrorMessage } from 'api';
const initial = {
    open: false,
    form_key: null,
    for_device_id: null,
    register__loading: false,
    register__fail: null,
};
export const reducer = (state = initial, action) => {
    switch (action.type) {
        case 'REGISTER_SIM_DIALOG__REGISTER__REQUEST':
            return { ...state, register__loading: true, register__fail: null };
        case 'REGISTER_SIM_DIALOG__REGISTER__OK':
            return {
                ...state,
                open: false,
                register__loading: false,
                register__fail: null,
            };
        case 'REGISTER_SIM_DIALOG__REGISTER__FAIL':
            return {
                ...state,
                register__loading: false,
                register__fail: getAPIErrorMessage(action.error, 'Не удалось зарегистрировать сим-карту'),
            };
        default:
            return state;
    }
};
